import { NavLink } from 'react-router-dom'
import confirmDelete from 'shared/utils/confirmDelete'
import * as Icon from 'react-bootstrap-icons'
import getAll from 'utils/getAll'
import { apiUrls } from 'consts'
import ActionButtons from 'shared/components/ActionButtons'

interface getRowsProps {
  setDeleteEntryId: Function
  setShowModal: Function
}

const getRows = async (props: getRowsProps) => {
  let data = await getAll(apiUrls.types, true)

  data.forEach((row: any, index: number, dataArray: any) => {
    dataArray[index].action = <ActionButtons buttons={[
      {
        type: 'u',
        url: '/edit-type/' + row.id
      },
      {
        type: 'd',
        id: dataArray[index].id,
        url: '/delete-type/' + row.id,
        setDeleteEntryId: props.setDeleteEntryId,
        setShowModal: props.setShowModal
      }
    ]} />

    dataArray[index].show = dataArray[index].show === 1 ? 'Yes' : 'No'
  })

  return data
}

export default getRows
